jQuery( document ).ready( function( $ ) {

  var $body = $('body');
  
  var lazyLoadInstance = new LazyLoad({
      elements_selector: ".lazyload"
  });
  
  // Product
  if ($body.hasClass('template-product')) {
  	
    // Thumbnails
    var $thumbnails = $('.product-thumbnails a');
    var $image = $('.product-main-image img');
    var $zoom = $('.zoom');
    
    $thumbnails.on('click', function(e) {
      	
      	e.preventDefault();
            
    	$image.attr('src', $(this).attr('href'));
      
      	// Update lazyload
      	lazyLoadInstance.update();
      
      	// Update zoom
      	$zoom.trigger('zoom.destroy').data('zoom', $(this).data('zoom')).zoom({
    		url: $('.zoom').data('zoom'), 
  		});   
    });
    
    // Zoom
   	$zoom.zoom({
    	url: $('.zoom').data('zoom'), 
  	});   
    
  } else if ($body.hasClass('template-index')) {
    
    // Slideshow
    if ($('.layout-slideshow').length > 0) {
    	$('.layout-slideshow').slick({
          autoplaySpeed: $('.layout-slideshow').data('speed'),
          autoplay: $('.layout-slideshow').data('autoplay'),
          dots: true,
          arrows: false,
          slide : '.slide',
          slidesToShow: 1,
          infinite: true,
		}).on('beforeChange', function(event, slick, currentSlide, nextSlide){
			lazyLoadInstance.update();
		});
    }

    // Down Arrow
    var $down = $('.button-down');

    if ($down.length > 0) {
      $down.on('click', function(e) {
          $('html, body').animate({
                 scrollTop: $('.layout-slideshow').offset().top + $('.layout-slideshow').height()
          }, 500); 	
        
        	console.log('clicked');
      });
    }  
    
  }
  
  // Quantity buttons
  $('.button-quantity').on('click', function(e) {
  	e.preventDefault();
    
    var $quantity = $(this).parent().find('input')
    var quantity = $quantity.val();
    
    if ($(this).hasClass('button-quantity-increase')) {
    	quantity++;	
    } else {
      if (quantity > 1) {
     	quantity--;
      }
    }
    
    $quantity.val(quantity);
    
  });
  
  // Toggle helper
  $body.on('click','[data-toggle]', function(e){
	e.preventDefault();
  	$body.toggleClass($(this).data('toggle'));
  });	  
 

});